import UnconfirmedEmailBannerLexique from 'locales/types/components/organisms/UnconfirmedEmailBanner';

export const unconfirmedEmailBannerLexique: UnconfirmedEmailBannerLexique = {
    description: 'Valide ton inscription en utilisant le lien envoyé à',
    resend: 'Renvoyer?',
    emailResent: `Un mail de confirmation vient d'être envoyé à : `,
};

export default unconfirmedEmailBannerLexique;
